import React from 'react';
import { BeVoucher } from 'types/voucher';

interface Props {
  status?: BeVoucher['actionStatus'];
  onClick?: () => void;
}

export const ButtonVoucherCTA = ({ status, onClick }: Props) => {
  let className = '';
  let text = '';

  const disabled = !onClick;

  switch (status) {
    case 'AVAILABLE': {
      className = 'min-w-fit bg-[var(--primary-color)] px-3 py-1.5 rounded-[30px] text-white font-[ggsr] text-[12px]';
      text = 'Sử dụng ngay';
      break;
    }
    case 'INVALID': {
      className = 'min-w-fit bg-[#EDFDF6] border-[1px] border-[#005c29] px-3 py-1.5 rounded-[30px] text-[#005c29] font-[ggsr] text-[12px]';
      text = 'Mua thêm';
      break;
    }
    case 'INUSE': {
      className = 'min-w-fit bg-white border-[1px] border-[#E9E9E9] px-3 py-1.5 rounded-[30px] text-[#005c29] font-[ggsr] text-[12px]';
      text = 'Đang sử dụng';
      break;
    }
    case 'DISABLED': {
      className = 'min-w-fit bg-[#F0F0F0] px-3 py-1.5 rounded-[30px] text-[#A2A0A0] font-[ggsr] text-[12px]';
      text = 'Sử dụng ngay';
      break;
    }
    default:
      break;
  }

  return (
    <button
      track-button-cta=""
      refer-data-root-voucher="short-name,code,expired-date,action-status,seller-name,usage-total"
      disabled={disabled}
      onClick={onClick}
      className={className}
    >
      {text}
    </button>
  );
};

